// Update Gallery view more button label on action
document.querySelectorAll('.additional-items-wrapper .occ-accordion__button').forEach(function(toggleBtn) {

    const accordionGroup = document.getElementById(toggleBtn.getAttribute('aria-controls'));
    accordionGroup.hidden = true;

    toggleBtn.addEventListener('click', function(e) {
        e.preventDefault();

        const element = this;
        const isExpanded = element.getAttribute('aria-expanded') === 'true';
        const buttonLabel = isExpanded ? 'View all':'View less';

        accordionGroup.hidden = !accordionGroup.hidden;
        element.setAttribute('aria-expanded', String(!isExpanded));
        element.textContent = buttonLabel;
    });
});
